import { useLocale, type Locale } from "@/contexts/LocaleContext";
import { Button } from "@/components/ui/button";
import { Globe } from "lucide-react";

export default function LanguageSwitcher() {
  const { locale, setLocale } = useLocale();

  const toggle = () => {
    const next: Locale = locale === "es" ? "en" : "es";
    setLocale(next);
  };

  return (
    <Button
      variant="ghost"
      size="sm"
      onClick={toggle}
      className="text-muted-foreground hover:text-gold gap-1.5 px-2"
      aria-label={locale === "es" ? "Switch to English" : "Cambiar a Español"}
    >
      <Globe className="h-4 w-4" />
      <span className="text-xs font-semibold uppercase tracking-wider">
        {locale === "es" ? "EN" : "ES"}
      </span>
    </Button>
  );
}
